import React, { useContext } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import GroupBiorepositoryOps from "../FieldTags/GroupBiorepositoryOps";
import HistoryLogElement from "./HistoryLogElement";
import { UserContext } from "../../context/UserContext";
import pullListLabels from '../../util/PullListLabels';
import ROLES from "../../util/roles";
import { checkRole } from "../../util/FormUtils";

/*
// Toggle switch
const CustomSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 56,
    height: 36,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 4,
        boxShadow: 'none',
        transitionDuration: '250ms',
        '&.Mui-checked': {
            transform: 'translateX(20px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'dark' ? '#003b57' : '#177ddc',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#40a9ff',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.mode === 'dark' ?  0.3 : 0.7,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'dark' ?  0.3 : 0.7,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        boxShadow: 'none',
        borderRadius: 14,
        width: 28,
        height: 28,
    },
    '& .MuiSwitch-track': {
        borderRadius: 18,
        backgroundColor: theme.palette.mode === 'dark' ? '#929ea8' : '#929ea8',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 400,
        }),
    },
}));
 */

const ShipmentFromRepo = ({ shipmentFromRepo, handleWorkflowChange, pullLists }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, ROLES.ELEVATED);

    return (
        <div className="planField">
            <GroupBiorepositoryOps />
            <FormControl required={true}>
                <FormLabel className="planRadioTitle">
                    {pullListLabels.shipmentFromRepo}
                </FormLabel>
                <RadioGroup
                    id="shipmentFromRepo-field"
                    name="shipmentFromRepo"
                    value={shipmentFromRepo}
                    onChange={(e) => handleWorkflowChange("shipmentFromRepo", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="Yes"
                        control={<Radio disabled={!canEdit} />}
                        label="Yes"
                    />
                    <FormControlLabel
                        value="No"
                        control={<Radio disabled={!canEdit} />}
                        label="No"
                    />
                </RadioGroup>
            </FormControl>
            {/*
            <Box display="flex" alignItems="center">
                <FormControlLabel
                    id="shipmentFromRepo-field"
                    name="shipmentFromRepo"
                    control={
                        <CustomSwitch
                            checked={shipmentFromRepo}
                            onChange={() => handleWorkflowChange("shipmentFromRepo", shipmentFromRepo === "Yes" ? "No" : "Yes")}
                            color="primary"
                            disabled={!checkRole(user, ROLES.ELEVATED)}
                        />
                    }
                    style={{ margin: "0px" }}
                />
                <Typography style={{ marginLeft: "12px" }}>{pullListLabels.shipmentFromRepo}</Typography>
            </Box>
            */}
            <HistoryLogElement pullLists={pullLists} label={"shipmentFromRepo"}/>
        </div>
    );
};

export default ShipmentFromRepo;